import React, { Component } from 'react';
import CompanyModal from './partial/company-modal';
import Firstname from './partial/firstname';
import Lastname from './partial/lastname';
import Company from './partial/company';
import Title from './partial/title';
import Email from './partial/email';
import Phone from './partial/phone';
import Country from './partial/country';
import State from './partial/state';
import GDPR from './partial/gdpr';

export default class Form extends Component {
  constructor(props){
    super(props);
    this.state = {
      showCountryError: false,
			showStateError: false,
      busy: false,
      showState: false,
      country: null,
      company: null,
      email: null,
      firstname: null,
      lastname: null,
      title: null,
      state: null,
      phone: null,
      isOptin: null
    }
  }  
  openSFModal(){
    if (!this.props.data){
      this.refs.companyModal.openModal();
    }
  }

  setShowState({value, label}){
    this.setState({
      showState: value === 'United States' || value === 'Canada',
      country: value
    })
  }
  setFormPanelClass(){
    var body = document.getElementsByTagName("BODY")[0];
    body.classList.toggle("show-result");
  }
  setEmail(value){
    this.setState({email: value})
  }
  setFirstName(value){
    this.setState({firstname: value})
  }
  setLastName(value){
    this.setState({lastname: value})
  }
  setCompany(value, fromRF){
    this.setState({company: value}, function(){
      if (!fromRF){
        this.openSFModal()
      }
    })
  }
  setPhone(value){
    this.setState({phone: value})
  }
  setTitle(value){
    this.setState({title: value})
  }
  setStateField(value){
    this.setState({state: value})
  }
  is_fields_ok(){
    let isAllValid = true  
    this.setState({
      showCountryError: false,
      showStateError: false
    })
    if (!this.state.country){
      this.setState({showCountryError: true})
      isAllValid= false
    }else{
      if ( (this.state.country === 'United States' || this.state.country === 'Canada') && !this.state.state) {
        this.setState({showStateError: true})
        isAllValid= false
      }
    }
    
    if (!this.refs.firstNameField.validate()){
      isAllValid= false;
    }
    if (!this.refs.lastNameField.validate()){
      isAllValid= false;
    }
    if (!this.refs.phoneField.validate()){
      isAllValid= false;
    }
    if (!this.refs.titleField.validate()){
      isAllValid= false;
    }
    // if (!this.refs.companyField.validate()){
    //   isAllValid= false;
    // }
    if (!this.refs.emailField.validate()){
      isAllValid= false;
    }
    return isAllValid
  }
  render(){
    // console.log(this.props.data)
    return (
      <div id="panel-form" className={"panel " + (this.props.active ? 'active': '') + (this.state.busy ? ' busy': '')}>
        
          <div className={"form-inner" + (this.props.data ? ' exist' : '')}>
            <CompanyModal ref="companyModal" setCompanyField={this.setCompany.bind(this)} />
            {
              !this.props.data &&
              <div className="form">
                <Firstname ref="firstNameField" setValue={this.setFirstName.bind(this)} />
                <Lastname ref="lastNameField" setValue={this.setLastName.bind(this)} />
                <Company ref="companyField" setValue={this.setCompany.bind(this)}/>
                <Title ref="titleField" setValue={this.setTitle.bind(this)} />
                <Email ref="emailField" setValue={this.setEmail.bind(this)} />
                <Phone ref="phoneField" setValue={this.setPhone.bind(this)} />
                <Country getSelectedOption={this.setShowState.bind(this)} showError={this.state.showCountryError} />
                {
                  this.state.showState &&
                  <State country={this.state.country} setValue={this.setStateField.bind(this)} showError={this.state.showStateError} />
                }
                {
                  this.state.country && this.state.country !== 'United States' && 
                  <GDPR country={this.state.country} />
                }
              </div>
            }
            {
              this.props.data && 
              <p>Hi {this.props.data.firstName}, please click the button below to get your result.</p>
            }

          </div>

      </div>
    )
  }
}